import React from 'react';
import {
	MimaButton,
	MimaInput,
	MimaText,
	MimaTextArea,
	Modal,
	ReceiptCheckBox as RCB,
} from '../../components';
import { Formik, FieldArray, Field } from 'formik';
import moment from 'moment';

const FieldInput = ({ field, ...props }) => {
	return <MimaInput {...field} {...props} />;
};

const UpdateQty = ({
	closeModal,
	loading,
	validationSchema,
	onSubmit,
	selectedStock,
}) => {
	const quantityTracker = selectedStock?.quantityTracker.map(obj => ({
		...obj,
		initialQty: parseFloat(obj.quantity || 0, 10).toFixed(2),
		quantity: '',
	}));

	return (
		<Modal closeModal={closeModal}>
			<MimaText variant="subtitleBold">Update Quantity</MimaText>
			<MimaText color="var(--color-primary)">
				Total Quantity: <b>{selectedStock.quantity}</b>
			</MimaText>
			<MimaText variant="small" mb={3}>
				Last updated:{' '}
				{moment(selectedStock?.quantityTracker[0]?.createdAt).format(
					'DD-MM-YYYY hh:mm A'
				)}
			</MimaText>
			<Formik
				initialValues={{
					quantity: '',
					reason: '',
					type: 'INCREASE',
					costPrice: '',
					quantityTracker,
				}}
				validationSchema={validationSchema}
				onSubmit={onSubmit}>
				{({
					handleChange,
					handleBlur,
					handleSubmit,
					setFieldValue,
					values,
					errors,
					touched,
				}) => (
					<div>
						<div className="modal__beside__grid">
							<RCB
								title="Increase Quantity"
								onChange={() => {
									setFieldValue('type', 'INCREASE');
								}}
								checked={values.type === 'INCREASE'}
								value="INCREASE"
								name="type"
							/>

							<RCB
								title="Reduce Quantity"
								onChange={() => {
									setFieldValue('type', 'DECREASE');
								}}
								checked={values.type === 'DECREASE'}
								value="DECREASE"
								name="type"
							/>
						</div>
						{values.type === 'INCREASE' && (
							<>
								<div className="modal__beside">
									<MimaInput
										labelTitle="Increase by"
										placeholder="Increase by"
										name="quantity"
										type="number"
										onChange={handleChange}
										value={values.quantity}
										error={errors.quantity}
										touched={touched.quantity}
										onBlur={handleBlur}
										width={18}
									/>
									<MimaInput
										labelTitle="Cost price"
										type="number"
										placeholder="Cost price"
										name="costPrice"
										onChange={handleChange}
										value={values.costPrice}
										error={errors.costPrice}
										touched={touched.costPrice}
										onBlur={handleBlur}
										width={18}
									/>
								</div>
								{values.quantity !== '' && (
									<MimaText
										variant="smallBold"
										color="var(--color-primary)"
										mb={2}>
										Total Quantity will increase to{' '}
										{Number(selectedStock.quantity) + values.quantity}
									</MimaText>
								)}
							</>
						)}

						{values.type === 'DECREASE' && (
							<>
								<MimaText
									variant="smallBold"
									color="var(--color-primary)"
									mb={2}
									width={38}
									align="center">
									Reduce the quantity with the corresponding cost price
								</MimaText>
								<FieldArray>
									{() => (
										<React.Fragment>
											{selectedStock.quantityTracker.map((item, i) => (
												<div
													key={i}
													style={{
														width: '38rem',
														padding: '1rem',
														borderRadius: '0.8rem',
														border: '1px solid var(--color-primary)',
														marginBottom: '2rem',
													}}>
													<div className="modal__beside__grid">
														<MimaText labelTitle="Entry Date">
															{moment(item?.createdAt).format('DD-MM-YY')}
														</MimaText>
														<MimaText labelTitle="Unit Quantity">
															{parseFloat(item?.quantity || 0, 10).toFixed(2)}
														</MimaText>
														<MimaText labelTitle="Unit Cost Price">
															{parseFloat(item?.costPrice || 0, 10).toFixed(2)}
														</MimaText>

														<Field
															name={`quantityTracker.${i}.quantity`}
															component={FieldInput}
															type="number"
															labelTitle="Reduce by"
															placeholder="Reduce by"
															width={18}
															touched={touched?.quantityTracker?.[i]?.quantity}
															error={errors?.quantityTracker?.[i]?.quantity}
														/>
													</div>
													{values.quantityTracker?.[i]?.quantity !== '' && (
														<MimaText
															variant="smallBold"
															color="var(--color-primary)"
															mb={2}>
															The Unit Quantity for this group will reduce to{' '}
															{item.quantity -
																values.quantityTracker?.[i]?.quantity}
														</MimaText>
													)}
												</div>
											))}
										</React.Fragment>
									)}
								</FieldArray>
							</>
						)}

						<MimaTextArea
							labelTitle="Reason (Max character 100)"
							name="reason"
							placeholder="Enter reason"
							value={values.reason}
							onChange={handleChange}
							error={errors.reason}
							touched={touched.reason}
							onBlur={handleBlur}
						/>

						<MimaButton
							title="Save"
							onClick={handleSubmit}
							loading={loading}
							mb={5}
						/>
					</div>
				)}
			</Formik>
		</Modal>
	);
};
export default UpdateQty;
